import moment from 'moment-timezone';

import fetchExpresso from 'utility/fetchExpresso';

export type ReportDateRange =
    | 'all-time'
    | 'today'
    | 'last-7-days'
    | 'last-30-days'
    | 'custom';

export type ReportDateRangeValue = {
    range: ReportDateRange;
    customStart?: string;
    customEnd?: string;
};

type DateRangeParams = {
    start?: string;
    end?: string;
};

export function getDateRangeParams(
    dateRange: ReportDateRangeValue,
    timezone: string,
): DateRangeParams {
    if (dateRange.range === 'all-time') {
        return {};
    }

    if (dateRange.range === 'custom') {
        if (dateRange.customStart && dateRange.customEnd) {
            return { start: dateRange.customStart, end: dateRange.customEnd };
        }

        return {};
    }

    const now = moment().tz(timezone);
    const end = now.format('YYYY-MM-DD');

    if (dateRange.range === 'today') {
        return { start: end, end };
    }

    if (dateRange.range === 'last-7-days') {
        return { start: now.clone().subtract(6, 'days').format('YYYY-MM-DD'), end };
    }

    return { start: now.clone().subtract(29, 'days').format('YYYY-MM-DD'), end };
}

export async function fetchReportData<T>(
    reportId: string,
    eventId: number,
    dateRange: ReportDateRangeValue,
    timezone: string,
): Promise<T[]> {
    const { start, end } = getDateRangeParams(dateRange, timezone);
    const params = new URLSearchParams();

    if (start) {
        params.set('start', start);
    }

    if (end) {
        params.set('end', end);
    }

    const query = params.toString();
    const url = `/apiv2/events/${eventId}/reports/${reportId}${query ? `?${query}` : ''}`;
    const res = await fetchExpresso(url);

    if (!res.ok) {
        throw new Error(`Failed to load ${reportId} report`);
    }

    const data = (await res.json()) as { rows: T[] };
    return data.rows;
}
